/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { dataTablesRequest } from '../models/dataTablesRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ReportService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get Report Sales
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postReportSalesDataTables({
        requestBody,
    }: {
        requestBody: dataTablesRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/report/sales/dataTables',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Report Sales
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postReportSalesDetailDataTables({
        requestBody,
        businessAreaId,
        storeId,
    }: {
        requestBody: dataTablesRequest,
        businessAreaId?: string,
        storeId?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/report/sales/detail/dataTables',
            query: {
                'businessAreaId': businessAreaId,
                'storeId': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Product Transfer
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postReportProductMovementDataTables({
        requestBody,
    }: {
        requestBody: dataTablesRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/report/product/movement/dataTables',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Product Movement Details Transfer
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postReportProductMovementDetailsDataTables({
        requestBody,
        businessAreaId,
        storeId,
    }: {
        requestBody: dataTablesRequest,
        businessAreaId?: string,
        storeId?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/report/product/movement/details/dataTables',
            query: {
                'businessAreaId': businessAreaId,
                'storeId': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Sales Store
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postReportSalesStoreDataTables({
        requestBody,
        businessAreaId,
        storeId,
    }: {
        requestBody: dataTablesRequest,
        businessAreaId?: string,
        storeId?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/report/sales/store/dataTables',
            query: {
                'businessAreaId': businessAreaId,
                'storeId': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Sales Store Summary
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postReportSalesSummaryDataTables({
        requestBody,
        businessAreaId,
        storeId,
    }: {
        requestBody: dataTablesRequest,
        businessAreaId?: string,
        storeId?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/report/sales/summary/dataTables',
            query: {
                'businessAreaId': businessAreaId,
                'storeId': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Sales Store
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postReportSalesYearlyDataTables({
        requestBody,
    }: {
        requestBody: dataTablesRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/report/sales/yearly/dataTables',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Total Real Stock
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public getReportTotalRealStock({
        businessAreaId,
        storeId,
    }: {
        businessAreaId?: string,
        storeId?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/report/total/real/stock',
            query: {
                'businessAreaId': businessAreaId,
                'storeId': storeId,
            },
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Real Stock
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postReportRealStockDataTables({
        requestBody,
        businessAreaId,
        storeId,
    }: {
        requestBody: dataTablesRequest,
        businessAreaId?: string,
        storeId?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/report/real/stock/dataTables',
            query: {
                'businessAreaId': businessAreaId,
                'storeId': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Stock Per Store
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postReportStockStoreDataTables({
        requestBody,
        businessAreaId,
        storeId,
    }: {
        requestBody: dataTablesRequest,
        businessAreaId?: string,
        storeId?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/report/stock/store/dataTables',
            query: {
                'businessAreaId': businessAreaId,
                'storeId': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Product Analyze
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postReportProductAnalyzeDataTables({
        requestBody,
        businessAreaId,
        storeId,
    }: {
        requestBody: dataTablesRequest,
        businessAreaId?: string,
        storeId?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/report/product/analyze/dataTables',
            query: {
                'businessAreaId': businessAreaId,
                'storeId': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Total Product Analyze
     * @returns any Get data successfully
     * @throws ApiError
     */
    public postReportProductAnalyzeTotal({
        requestBody,
        businessAreaId,
        storeId,
    }: {
        requestBody: Array<string>,
        businessAreaId?: string,
        storeId?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/report/product/analyze/total',
            query: {
                'businessAreaId': businessAreaId,
                'storeId': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Sales All Store
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postReportSalesAllstoreDataTables({
        requestBody,
        businessAreaId,
        storeId,
    }: {
        requestBody: dataTablesRequest,
        businessAreaId?: string,
        storeId?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/report/sales/allstore/dataTables',
            query: {
                'businessAreaId': businessAreaId,
                'storeId': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Sales Recap
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postReportSalesRecapDataTables({
        requestBody,
        businessAreaId,
        storeId,
    }: {
        requestBody: dataTablesRequest,
        businessAreaId?: string,
        storeId?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/report/sales/recap/dataTables',
            query: {
                'businessAreaId': businessAreaId,
                'storeId': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Sales Assortment
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postReportSalesAssortmentDataTables({
        requestBody,
        businessAreaId,
        storeId,
    }: {
        requestBody: dataTablesRequest,
        businessAreaId?: string,
        storeId?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/report/sales/assortment/dataTables',
            query: {
                'businessAreaId': businessAreaId,
                'storeId': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Total Sales Assortment
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public getReportTotalSalesAssortment({
        startDate,
        endDate,
        businessAreaId,
        storeId,
        productArticle,
    }: {
        startDate?: string,
        endDate?: string,
        businessAreaId?: string,
        storeId?: string,
        productArticle?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/report/total/sales/assortment',
            query: {
                'startDate': startDate,
                'endDate': endDate,
                'businessAreaId': businessAreaId,
                'storeId': storeId,
                'productArticle': productArticle,
            },
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Stock Per Store
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postReportStockProductDataTables({
        requestBody,
        businessAreaId,
        storeId,
    }: {
        requestBody: dataTablesRequest,
        businessAreaId?: string,
        storeId?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/report/stock/product/dataTables',
            query: {
                'businessAreaId': businessAreaId,
                'storeId': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Article Group Percentage
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postReportArticleGroupPercentageDataTables({
        requestBody,
        businessAreaId,
        storeId,
        standardStock,
    }: {
        requestBody: dataTablesRequest,
        businessAreaId?: string,
        storeId?: string,
        standardStock?: number,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/report/article/group/percentage/dataTables',
            query: {
                'businessAreaId': businessAreaId,
                'storeId': storeId,
                'standardStock': standardStock,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Product Age
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postReportProductAgeDataTables({
        requestBody,
        businessAreaId,
        storeId,
        minAge,
    }: {
        requestBody: dataTablesRequest,
        businessAreaId?: string,
        storeId?: string,
        minAge?: number,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/report/product/age/dataTables',
            query: {
                'businessAreaId': businessAreaId,
                'storeId': storeId,
                'minAge': minAge,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

}
